import { Component, ViewChild, TemplateRef, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { InvoiceService } from '../../../services/invoice/invoice.service';
import { DashboardServicesService } from '../../../services/dashboard-services/dashboard-services.service';
import { Observable } from 'rxjs';
import { LogDto } from '../../../models/dto/log.dto';
import { Action } from '../../../models/enums/action.enum';
import { LogService } from '../../../services/log/log.service';
import { Screen } from '../../../models/enums/screen.enum';
import * as jwt_decode from "jwt-decode";
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../core/reducers';
import { selectAuthState } from '../../../core/auth/_selectors/auth.selectors';
import { orderInProgressService } from '../orders-in-progress/orders-in-progress.service';
import { TrackingServiceService } from '../../../services/tracking-service.service'

import { url } from 'inspector';
import { Subscription } from 'rxjs/Subscription';

declare var $: any;

@Component({
  selector: 'kt-share-order',
  templateUrl: './share-order.component.html',
  styleUrls: ['./share-order.component.scss']
})
export class ShareOrderComponent implements OnInit {
  @ViewChild('impedimento', { static: true }) impedimento: TemplateRef<any>;
  @ViewChild('sharebl', { static: true }) sharebl: TemplateRef<any>;
  @ViewChild('sharedata', { static: true }) sharedata: TemplateRef<any>;
  @ViewChild('calificar', { static: true }) calificar: TemplateRef<any>;
  public viewDetail = false;
  public expandupdates = false;
  public blexpandupdates = true;
  public dropDownExpand = false;
  public sharelink: any;
  public isChecked: any;
  public indexno: any;
  public tarjaIndexNo = 0;
  public innerIndexNo: any;
  public billOfLadingDropdown = false;
  public tarjaDetailsDropdown = true;
  public bookmarkactive = false;
  public active = false;
  public tarjaDetailsActive = true;
  public innerindexactive = false;
  public rightsidepanel = false;
  public almacenGeneral = false;
  public gestionAduanal = false;
  public almacenDesconsolidacion = false;
  public transpTerrestre = false;
  public transpAereo = false;
  public transpMaritima = false;
  public bls: any = [];
  public blSelected: string = '';
  public blData: any = {}
  public blErrors: any = {}
  public searchForm: FormGroup;
  public orderInProgressList: any = [];
  public page: number = 1;
  public invoicePage: number = 1;
  public notRows: boolean;
  public impedementActiveIndex: any;
  public selectedData: any;
  public selectedTarjaData: any;
  public title: any;
  public status: "";
  public containersList: any = [];
  public tarjasList: any = [];
  public customesList: any = [];
  public wisReferencesList: any = [];
  public blThStatusDetails: any = [];
  public windipList: any;
  public poList: any;
  public blStatusDetails: any;
  public blStatusDetailsHorizontal: any;
  public blThStatusDetils: any = [];
  public invoices: any;
  public payload$: Observable<any>;
  public actionId: any;
  public sortOrder: any;
  public orderOn: any = 'dt';
  public size: number = 10;
  public search: any = '';
  public getSystem: any;
  public allStatus: any;
  public firstDate: any;
  public lastDate: any;
  public transportData: any;
  public transpTerrestreDetails: any;
  public transpTerrestreStatus = [];
  public selectedTraja: any;
  public associatedBls = [];
  public tarjaDetails: any;
  public blHijoNumber: any;
  public documentList = [];
  public blNumber: any = '';
  public sharedtype: any;
  ratingcomments: boolean = false;
  public comments: any;
  blnum: any;
  ratingstar: any = {};
  public commentsdisable: boolean = false;
  ratingstardisable: boolean = false;
  subscription: Subscription;
  poPort = '';
  public selectedCompanyID;


  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private dashboardServices: TrackingServiceService,
    private changeDetectorRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private invoiceService: InvoiceService,
    private store: Store<AppState>,
    private logService: LogService,
    private router: Router,
    private orderinprogress: orderInProgressService
  ) {
    $('body').tooltip({ selector: '[data-toggle=tooltip]' });
    this.subscription = this.orderinprogress.getData().subscribe(x => {
      // this.Calificarbtn = x.calificar
      this.blnum = x.blnumber
    });
  }

  numSequence(n: number): Array<number> {
    return Array(n);
  }

  ngOnInit() {
    this.genrateForm();
    this.route.params.subscribe(params => {
      this.title = 'Localiza tus Cargas'
      this.searchForm.controls.referenceNo.setValue(params.type);
      // this.sharedtype = params.sharing;
      if (params.sharing) {
        this.searchForm.controls.referenceType.setValue(params.sharing);
      }
    })
    this.selectedCompanyID = localStorage.getItem("SelectedcompanyID");
    if (this.title == 'Favoritos') {
      this.getFavoritos()
    } else {
      this.getOrderInProgressList();
    }
    this.integrateAuditApi();
  }

  integrateAuditApi() {
    this.payload$ = this.store.pipe(select(selectAuthState));
    this.payload$.subscribe(res => {
      let tokenData = jwt_decode(res.authToken)
      this.logService.postWithPayload(<LogDto>{
        ActionId: this.actionId,
        ScreenId: Screen.IniCio,
        Json: '',
        UserName: res.user.fullname,
        Email: res.user.email,
        ClientId: tokenData['https://mardom.com/clientId'] == '' ? null : tokenData['https://mardom.com/clientId'],
        RoleName: tokenData['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'][0]
      },
        res.authToken);
    })
  }

  copylink(): void {
    navigator.clipboard.writeText(this.sharelink).then(res => {
      this.toastrService.success('Copied to Clipboard')
      this.cancel()
    }).catch(() => {
      console.error("Unable to copy text");
    });
  }

  counter(i: number) {
    return new Array(i);
  }

  changeImpedementOnList(index, order) {
    this.impedementActiveIndex = index;
    this.selectedData = order;
    this.modalService.open(this.impedimento, {
      size: 'm', backdrop: 'static', centered: true
    });
  }

  changeImpedementOnTarjaList(index, tarja) {
    this.impedementActiveIndex = index;
    this.selectedTarjaData = tarja;
    this.modalService.open(this.impedimento, {
      size: 'm', backdrop: 'static', centered: true
    });
  }

  openDetailsBill(i: any, order) {
    if (this.selectedData && this.selectedData.blNumber == order && order.blNumber) {
      this.selectedData = order;
    } else {
      this.selectedData = order;
      this.containersList = [];
      this.tarjasList = [];
      this.customesList = [];
      this.wisReferencesList = [];
      if (!this.invoices) {
        this.getInvoices(order.blNumber);
      }
      this.dashboardServices.getAllReferences(order.blNumber, order.system).subscribe(res => {
        this.tarjasList = res && res.tarjas && res.tarjas.tally ? res.tarjas.tally : [];
        if (res.contenedores.containers != null) {
          this.removeDublicatedContainer(res);
        }
        this.documentList = res.documents;
        this.poList = res.poNumber
        this.changeDetectorRef.detectChanges();
      }, (error) => {
        this.toastrService.error('Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo serviciosit@mardom.com');
      })
    }
    this.billOfLadingDropdown = this.indexno != i ? true : !this.billOfLadingDropdown
    this.active = this.indexno != i ? true : !this.active;
    this.indexno = i;
    this.rightsidepanel = this.active ? true : false;
    // localStorage.setItem('calificarbtn' , JSON.stringify(this.rightsidepanel))
    this.orderinprogress.sendData(
      {
        calificar: this.rightsidepanel,
        blnumber: order.blNumber
      }
    );
  }

  removeDublicatedContainer(response) {
    let contenerList = response.contenedores.containers;
    contenerList.forEach(element => {
      if(typeof this.containersList.find(x => x == element) == 'undefined') {
        this.containersList.push(element)
      }
    });
  }

  downloadDocumnet(doc) {
    let filepath = doc.documentpath.split(/\\\\(.*)/s)
    let netpath = doc.documentpath.split('\\');
    let filepaths = "\\" + filepath[1].split('\\').slice(1).join('\\')
    if (doc.system == 'WINDIP') {
      this.dashboardServices.downloadWindipDocumnet("\\" + netpath[2], filepaths).subscribe(response => {
        const url = window.URL.createObjectURL(response);
        var fileLink = document.createElement('a');
        fileLink.href = url;
        fileLink.download = doc.documentname;
        fileLink.click();
      }),
        error => console.log('Error downloading the file'),
        () => console.info('Archivo descargado exitosamente');
    } else {
      this.dashboardServices.downloadDocumnet(doc.documentid).subscribe(response => {
        const url = window.URL.createObjectURL(response);
        var fileLink = document.createElement('a');
        fileLink.href = url;
        fileLink.download = doc.documentname;
        fileLink.click();
      }, (error) => {
        this.toastrService.info('Archivo no encontrado');
      })
    }

  }

  getInvoices(blnum: any) {
    this.dashboardServices.getInvoicesbyBl(this.invoicePage, blnum).subscribe(response => {
      this.invoices = response.results;
      this.invoices['total'] = response.total
      this.changeDetectorRef.detectChanges();
    }, (error) => {
      this.invoices = ''
    })
    // this.invoiceService
    //     .getPendingInvoices(this.invoicePage, '')
    //     .subscribe((data) => {
    //       this.invoices = data.results;
    //       this.invoices['total'] = data.total
    //       this.changeDetectorRef.detectChanges();
    //     }, (error) => {
    //       this.toastrService.error('Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo mardomgo@mardom.com');
    //     })
  }

  onPageChangeInvoice(event) {
    this.invoicePage = event;
    this.getInvoices(this.selectedData.blNumber);
  }

  downloadInvoice(invoice) {
    if (invoice.isFromDynamic) {
      this.invoiceService.downloadDynamicBillNew(invoice.clientId, invoice.rnc, invoice.number).subscribe(response => {
        // const url = window.URL.createObjectURL(response);
        var fileLink = document.createElement('a');
        fileLink.setAttribute('target', '_blank');
        fileLink.href = response;
        fileLink.click();
      })
    } else if (invoice.company == 'FreightForward') {
      this.invoiceService.downloadBillFreightForward(invoice.number).subscribe(response => {
        const url = window.URL.createObjectURL(response);
        //window.open(url);    
        var fileLink = document.createElement('a');
        fileLink.setAttribute('target', '_blank');
        fileLink.href = url;
        fileLink.click();
        //window.open(url,sfile.file_type);    

      }), error => console.log('Error downloading the file'),
        () => console.info('File downloaded successfully');
    } else {
      this.invoiceService.downloadBill(invoice.id).subscribe(response => {

        const url = window.URL.createObjectURL(response);
        var fileLink = document.createElement('a');
        fileLink.setAttribute('target', '_blank');
        fileLink.href = url;
        fileLink.click();
        //window.open(url);    
      }), error => console.log('Error downloading the file'),
        () => console.info('File downloaded successfully');
    }
  }


  openbilloflading(i: any) {
    this.indexno = i
    this.billOfLadingDropdown = !this.billOfLadingDropdown
    this.active = !this.active
  }

  opentarjaDetails(i: any, tarja) {
    if (this.blHijoNumber != tarja.blNumber) {
      this.blHijoNumber = tarja.blNumber
      this.getBlDetailsStatus()
    }
    this.tarjaDetailsDropdown = this.tarjaIndexNo != i ? true : !this.tarjaDetailsDropdown
    this.tarjaDetailsActive = this.tarjaIndexNo != i ? true : !this.tarjaDetailsActive;
    this.tarjaIndexNo = i
  }

  opentranspTerrestreDetils(i, data) {
    let system = this.allStatus.systems
    this.dashboardServices.getTranspTerrestreDetils(data.solicitudTransporte, system).subscribe(response => {
      this.transpTerrestreDetails = response;
      this.transpTerrestreDetilsStatus()
      this.billOfLadingDropdown = this.indexno != i ? true : !this.billOfLadingDropdown
      //this.active = this.indexno != i ? true : !this.active;
      this.indexno = i;
      this.innerIndexNo = -1;
      this.changeDetectorRef.detectChanges();
    }, (error) => {
      this.toastrService.error('Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo mardomgo@mardom.com');
    })
  }

  transpTerrestreDetilsStatus() {
    this.transpTerrestreDetails.forEach(element => {
      if (element.retirementDate || element.fechaplanificada) {
        this.transpTerrestreStatus.push({
          status: 'Transporte Terrestre Planificado',
          date: element.retirementDate
        })
      }
      if (element.fecharetorno) {
        this.transpTerrestreStatus.push({
          status: 'Retorno',
          date: element.fecharetorno
        })
      }
      if (element.retirementDate || element.fechafinalizada) {
        this.transpTerrestreStatus.push({
          status: 'En Transito A Destino Final',
          date: element.returnDate
        })
      }
      if (element.finalGpsDate) {
        this.transpTerrestreStatus.push({
          status: 'Transporte Entregado',
          date: element.finalGpsDate
        })
      }
      this.transpTerrestreStatus = this.transpTerrestreStatus.sort((a, b) => {
        return <any>new Date(b.date) - <any>new Date(a.date);
      });
      element['status'] = this.transpTerrestreStatus;
      this.transpTerrestreStatus = [];
    });
  }


  opentranspTerrestreDetilsStatus(data: any, i: any) {
    this.blThStatusDetils = [];
    this.dropDownExpand = this.innerIndexNo != i ? true : !this.dropDownExpand
    this.innerindexactive = this.innerIndexNo != i ? true : !this.innerindexactive;
    this.innerIndexNo = i
    this.thHorizontalDetails();
    this.changeDetectorRef.detectChanges();
  }

  thHorizontalDetails() {
    this.transpTerrestreDetails.forEach((element, index) => {
      if (this.dropDownExpand && this.innerindexactive && (this.innerIndexNo == index)) {
        this.blThStatusDetils = this.transpTerrestreDetails[index].status;
      }
    })

  }

  bookmark(i: any) {
    this.indexno = i
    this.bookmarkactive = !this.bookmarkactive
  }

  getBlDetailsStatus() {
    this.almacenGeneral = false;
    this.gestionAduanal = false;
    this.transpTerrestre = false;
    this.transpAereo = false;
    this.transpMaritima = false;
    this.tarjaDetailsDropdown = true;
    this.tarjaDetailsActive = true;
    this.tarjaIndexNo = 0;
    /*if(system == 'WIS' && id > 0) {
      this.toastrService.warning("Si desea ver los detalles desde WIS, se debe consultar desde el numero de agenda");
    }
    else {
    this.dashboardServices.getConsolidateTracking(this.blHijoNumber ? this.blHijoNumber : this.selectedData.blNumber, system).subscribe(res => {
        //debugger
        this.billOfLadingDropdown = false;
        this.active = false;
        this.viewDetail = true;
        this.allStatus = res;
        this.blStatusDetails = res.thEvents;
        this.blStatusDetailsHorizontal = res.thEvents;
        this.getSystem = res.systems;
        this.updateStatus(this.tarjaDetails ? 'TH' : res.systems[0]);
        this.changeDetectorRef.detectChanges();
      },(error) => {
        this.toastrService.error('Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo serviciosit@mardom.com');
      })
    }*/
   this.dashboardServices.getConsolidateTracking(this.blHijoNumber ? this.blHijoNumber : this.selectedData.blNumber, this.selectedData.system).subscribe(res => {
      //debugger
      this.billOfLadingDropdown = false;
      this.active = false;
      this.viewDetail = true;
      this.allStatus = res;
      this.blStatusDetails = res.thEvents;
      this.blStatusDetailsHorizontal = res.thEvents;
      this.getSystem = res.systems;
      this.updateStatus(this.tarjaDetails ? 'TH' : res.systems[0]);
      this.changeDetectorRef.detectChanges();
    },(error) => {
      this.toastrService.error('Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo serviciosit@mardom.com');
    })
  }

  getTarjasDetailsList(order) {
    order = this.orderInProgressList[0];
    if (this.tarjasList.length != 0) {
      this.dashboardServices.getTarjasDetails(this.tarjasList, order.blNumber).subscribe(response => {
        this.tarjaDetails = response;
        this.blHijoNumber = this.tarjaDetails ? this.tarjaDetails[0].blNumber : '';
        this.almacenDesconsolidacion = true;
        this.getBlDetailsStatus();
        this.changeDetectorRef.detectChanges();
        },(error) => {
          this.toastrService.error('Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo mardomgo@mardom.com');
        });
    } 
    else {
      this.blHijoNumber = '';
      this.tarjaDetails = '';
      this.getBlDetailsStatus();
    }
  }

  updateStatus(type) {
    if (type == 'TH') {
      this.blStatusDetailsHorizontal = this.allStatus.thEvents;
      this.blStatusDetailsHorizontal = this.sortByDateH();
      this.removeStatus();
      this.blStatusDetails = this.allStatus.thEvents;
      this.blStatusDetails = this.sortByDate();
      this.firstDate = this.blStatusDetailsHorizontal[0];
      this.lastDate = this.blStatusDetailsHorizontal[this.blStatusDetailsHorizontal.length - 1];
      this.firstDate = this.blStatusDetails[0];
      this.lastDate = this.blStatusDetails[this.blStatusDetails.length - 1];
      this.viewDetail = true;
      this.verticalStatusRemove()
      this.almacenDesconsolidacion = true;
      this.blThStatusDetails = [];
    } 
    else if (type == 'WINDIP') {
      this.blStatusDetailsHorizontal = this.allStatus.windipEvents;
      this.blStatusDetailsHorizontal = this.sortByDateH();
      this.removeStatus();
      this.statusUpdate();
      this.blStatusDetails = this.allStatus.windipEvents;
      this.blStatusDetails = this.sortByDate();
      this.firstDate = this.blStatusDetailsHorizontal[0];
      this.lastDate = this.blStatusDetailsHorizontal[this.blStatusDetailsHorizontal.length - 1]
      this.firstDate = this.blStatusDetails[0];
      this.lastDate = this.blStatusDetails[this.blStatusDetails.length - 1]
      this.viewDetail = true;
      this.gestionAduanal = true;
      this.blThStatusDetails = [];
      this.verticalStatusRemove();
    }
    else if (type == 'Silver Bullet' || type == 'Camiencito') {
      if (type == 'Silver Bullet') {
        this.blStatusDetailsHorizontal = this.allStatus.silverBulletEvents;
        this.blStatusDetailsHorizontal = this.sortByDateH();
        this.blStatusDetails = this.allStatus.silverBulletEvents;
        this.transpTerrestreDetails = this.allStatus.silverBulletEvents[0].eventsList;
      } 
      else if (type == 'Camiencito') {
        this.firstDate = ''
        this.lastDate = '';
        this.blStatusDetailsHorizontal = [];
        this.blStatusDetails = [];
        this.transportData = this.allStatus.camiencitoevents;
        this.transpTerrestre = true
      }
      this.transpTerrestre = true
    } 
    else if (type == 'WIS') {
      this.blStatusDetailsHorizontal = this.allStatus.wisEvents;
      this.blStatusDetailsHorizontal = this.sortByDateH();
      this.removeStatus();
      this.blStatusDetails = this.allStatus.wisEvents;
      this.blStatusDetails = this.sortByDate();
      this.viewDetail = true;
      this.almacenGeneral = true
      this.verticalStatusRemove()
    } 
    else if (type == 'PO Control') {
      this.blStatusDetailsHorizontal = this.allStatus.poEvents;
      this.blStatusDetails = this.allStatus.poEvents;
      this.blStatusDetails = this.sortByDate();
      this.viewDetail = true;
      if (this.poPort == 'Aerea') {
        this.transpAereo = true;
      } 
      else if (this.poPort == 'Maritima') {
        this.transpMaritima = true;
      }
    } 
    else if (type == 'TMS') {
      this.firstDate = ''
      this.lastDate = '';
      this.blStatusDetailsHorizontal = [];
      this.blStatusDetails = [];
      this.transportData = this.allStatus.tmSevents;
      this.transpTerrestre = true
    } 
    else {
      this.blStatusDetailsHorizontal = []
      this.blStatusDetails = [];
      this.blThStatusDetails = [];
      this.firstDate = '';
      this.lastDate = '';
    }
  }

  statusUpdate() {
    let blstat = this.blStatusDetailsHorizontal.filter(a => {
      if (a.system == 'WINDIP') {
        return (
          a.trackstatus != 'Verificado'
        )
      }
    });
    this.blStatusDetailsHorizontal = blstat;
  }

  openTranspTerrestreDetails(i, data) {
    this.transpTerrestreDetails = data.eventsList;
    this.billOfLadingDropdown = this.indexno != i ? true : !this.billOfLadingDropdown;
    this.indexno = i;
    this.innerIndexNo = -1;
    this.changeDetectorRef.detectChanges();
  }

  removeStatus() {
    let blStatusDetailss = this.blStatusDetailsHorizontal.filter(i => {
      return (
        (i.trackstatus != 'Facturado' && i.trackstatus != 'Solicitud De Gestion Aduanal Creada' && i.trackstatus != 'En Clasificacion Arancelaria' && i.trackstatus != 'DesParaPago' && i.trackstatus != 'En proceso de verificación' && i.trackstatus != 'Valores enviados para pago')
      );
    });
    this.blStatusDetailsHorizontal = blStatusDetailss;
  }

  verticalStatusRemove() {
    let verticalstatremove = this.blStatusDetails.filter(b => {
      return (
        (b.trackstatus != 'Facturado' && b.trackstatus != 'DesParaPago' && b.trackstatus != 'En proceso de verificación')
      );
    });
    this.blStatusDetails = verticalstatremove;
  }

  sortByDate() {
    return this.blStatusDetails.sort((a, b) => {
      return <any>new Date(b.trackdate) - <any>new Date(a.trackdate);
    });
  }

  sortByDateH() {
    return this.blStatusDetailsHorizontal.sort((a, b) => {
      return <any>new Date(b.trackdate) - <any>new Date(a.trackdate);
    });
  }


  cancel() {
    this.modalService.dismissAll();
    // let switchRound = document.getElementById("togBtn-" + this.impedementActiveIndex) as HTMLInputElement
    // switchRound.checked = false;
  }

  share(order) {
    let sharedtype = '';
    if (order.system == 'WINDIP') {
      sharedtype = 'bl';
    } else if (order.system == 'WIS') {
      sharedtype = 'agenda';
    }
    // else if (order.system == 'TH') {
    //   sharedtype = 'contenedor';
    // } else if(order.system == 'TH'){
    //   sharedtype = 'tarja';
    // }
    else {
      sharedtype = 'bl';
    }

    var blString = order.blNumber;
    blString = blString.replace(/\//g, "%2F");
    order.blNumber = blString;

    this.sharelink = window.location.origin + "/order/" + order.blNumber + "/" + sharedtype;
    this.selectedData = order
    this.modalService.open(this.sharedata, {
      size: 'm', backdrop: 'static', centered: true
    });
  }

  searchPedidoEnCruso() {
    this.page = 1
    let datefrom = this.searchForm.controls.fromDate.value;
    let dateto = this.searchForm.controls.toDate.value;
    this.billOfLadingDropdown = false;
    this.active = false;
    this.rightsidepanel = false
    if ((datefrom || dateto) && (datefrom && dateto) && (datefrom > dateto)) {
      this.toastrService.info("La fecha en 'Fecha Hasta' debe de ser mayor a 'Fecha Desde'.");
    } else if (this.searchForm.controls.referenceType.value) {
      //if (this.searchForm.controls.referenceNo.value) {
      this.getOrderInProgressList();
      /* } else {
        this.toastrService.info("Por favor ingrese Referencia");
      } */
    } else {
      this.getOrderInProgressList();
      // this.toastrService.error("Por favor ingrese los campos obligatorios");
    }
  }

  getFavoritos() {
    this.dashboardServices.getFavoritosList(this.page, this.size, this.selectedCompanyID).subscribe(response => {
      this.orderInProgressList = response.orders
      this.orderInProgressList.total = response['total'];
      this.notRows = response['total'] == '0';
      this.almacenDesconsolidacion = false;
      this.transpTerrestre = false;
      this.viewDetail = false;
      this.orderInProgressList.forEach(element => {
        element['addToFavourite'] = true
      });
      this.changeDetectorRef.detectChanges();

    }, (error) => {
      this.toastrService.error('Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo mardomgo@mardom.com');
    })
  }

  private getOrderInProgressList(): void {
    const formValues = this.searchForm.controls;
    const referenceNo = formValues.referenceNo.value || this.blNumber;
    const status = formValues.status.value || this.status;
    const referenceType = formValues.referenceType.value;

    const payload = {
      fromDate: formValues.fromDate.value || null,
      toDate: formValues.toDate.value || null,
      referenceNo,
      status,
      referenceType,
      orderOn: this.orderOn || 'dt',
      orderBy: this.sortOrder || 'desc',
      startWith: this.search,
    };

    //this.sharing = referenceType;
    this.dashboardServices.getOrderInProgressList(this.page, this.size, payload).subscribe(
      (response) => {
        this.orderInProgressList = [];
        if (referenceNo && response.orders.length > 0) {
          this.orderInProgressList.push(response.orders[0]);
        } else {
          this.orderInProgressList = response.orders;
        }
        this.orderInProgressList.total = response.total;
        this.notRows = response.total == '0';
        //this.resetViewState();
        this.setFavoritos(response.favourites);
        /*if (this.clientRole.includes('coordinator') && response.total >= 10000) {
          this.orderInProgressList.total = 10000;
        }*/
        if (this.blNumber) {
          this.openDetailsBill(0, this.orderInProgressList[0]);
        }
        //this.updateNavigationAndTitle(status);
        //this.Client = this.clientRole.includes('Client');
        this.changeDetectorRef.detectChanges();
      },
      (error) => {
        this.toastrService.error(
          'Ha ocurrido un error, favor intente de nuevo. Si el error persiste, comunicarse al correo serviciosit@mardom.com'
        );
      }
    );
  }

  private setFavoritos(favourites) {
    if (favourites) {
      this.orderInProgressList.forEach(element => {
        let blNumber = favourites.find(item => item == element.blNumber);
        if (blNumber) {
          element['addToFavourite'] = true
        }
      });
    }
  }

  public updateImpediment() {
    let paylod = {}
    paylod = {
      id: this.selectedData.id,
      Impediment: true
    }
    this.dashboardServices.updateImpediment(paylod).subscribe((data) => {
      this.changeDetectorRef.detectChanges();
      this.toastrService.success("Actualización de estado de Impedimento con éxito")
      this.modalService.dismissAll();
    }, (error) => {
      this.toastrService.error('Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo mardomgo@mardom.com');
    })
  }

  selectTarja(traja) {
    this.selectedTraja = traja
  }

  onPageChange(item: number) {
    this.page = item;
    if (this.title == 'Favoritos') {
      this.getFavoritos()
    } else {
      this.getOrderInProgressList();
    }
  }

  sortList(event, order) {
    if (order == 'asc') {
      this.sortOrder = 'asc'
    } else if (order == 'desc') {
      this.sortOrder = 'desc'
    } else if (event.target.value == 'bl') {
      this.orderOn = 'bl'
      this.sortOrder = 'asc'
      this.getOrderInProgressList();
    } else if (event.target.value == 'dt') {
      this.orderOn = 'dt';
      this.sortOrder = 'desc'
      this.getOrderInProgressList();
    }
    event.stopPropagation();
  }

  selectSize(event) {
    this.size = event.target.value;
    this.getOrderInProgressList();
  }

  clearSort() {
    this.search = ""
    this.sortOrder = "desc"
    this.orderOn = "dt"
    this.page = 1
    this.getOrderInProgressList();
  }

  clearFilter() {
    this.page = 1
    this.searchForm.controls.fromDate.setValue('');
    this.searchForm.controls.toDate.setValue('');
    this.searchForm.controls.referenceNo.setValue('');
    this.searchForm.controls.referenceType.setValue('bl');
    this.searchForm.controls.status.setValue(this.status);
    this.sortOrder = '';
    this.orderOn = '';
    this.search = '';
    this.indexno = -1;
    this.almacenGeneral = false;
    this.gestionAduanal = false;
    this.almacenDesconsolidacion = false;
    this.transpTerrestre = false;
    this.transpAereo = false;
    this.transpMaritima = false;
    this.blNumber = '';
    this.rightsidepanel = false
    this.router.navigate(['/order']);
    if (this.title == 'Favoritos') {
      this.getFavoritos()
    } else {
      this.getOrderInProgressList();
    }
  }

  previousPage() {
    if (this.viewDetail == true) {
      this.viewDetail = false;
      this.blexpandupdates = true;
      this.billOfLadingDropdown = true;
      this.active = !this.active
      this.firstDate = '';
      this.lastDate = '';
      this.gestionAduanal = false;
      this.almacenDesconsolidacion = false;
      this.blNumber = '';
      this.rightsidepanel = true;
      this.orderinprogress.sendData(
        {
          calificar: false,
          blnumber: ""
        }
      );
    } else if (this.billOfLadingDropdown == true) {
      this.billOfLadingDropdown = false;
      this.rightsidepanel = false;
      this.getOrderInProgressList();
    } else {
      this.router.navigate(['login']);
    }
  }

  genrateForm() {
    this.searchForm = this.formBuilder.group({
      status: [''],
      fromDate: '',
      toDate: '',
      referenceType: ['bl'],
      referenceNo: ''
    });
  }
}